import { useState, useEffect } from "react";
import * as nativeEvents from "../../Helper/native";
import Card from '../../components/UI/Card';
import PopupCongratsTitle from "../../components/UI/PopupCongratsTitle";
import BackButton from "../../components/UI/BackButton";
import { FiChevronLeft } from "react-icons/fi";
import ConfettiComp from "../UI/Confetti";
import Modal from 'react-modal';
import * as APIHelper from '../../Helper/apiFetch';
Modal.setAppElement("#root");

export default function SendGift(props) {
    var { reward } = props

    const [modal, setModal] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        setIsOpen(true);
        return () => {
            setModal(false);
            document.body.classList.remove('active-model')
            document.body.style.overflow = 'auto'
        }
    }, [])

    useEffect(() => {
        if (modal) {
            document.body.classList.add('active-model')
            document.body.style.overflow = 'hidden'
        } else {
            document.body.classList.remove('active-model')
            document.body.style.overflow = 'auto'
        }
    }, [modal])

    const close = () => {
        setIsOpen(false);
    }

    const handelMessage = e => {
        console.log(e.target.value)
        setMessage(e.target.value);
    }

    return (
        <div>
            {
                modal && (
                    <Modal
                        isOpen={isOpen}
                        closeTimeoutMS={500}
                        className="mymodal"
                        contentLabel="My dialog"
                        overlayClassName="myoverlay"
                    >
                        <ConfettiComp />
                        <div>
                            <div className="popupBackButtonContainer">
                                <button className='back-button' onClick={close}>
                                    <FiChevronLeft className='back-button-icon' />
                                </button>
                            </div>
                            <div style={{ color: '#FFFFFF', height: '100vh', paddingTop: '10%' }}>
                                <div>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <Card title={reward} />
                                    </div>
                                    <PopupCongratsTitle title={reward} />
                                    <div style={{ backgroundColor: '#2A2E31', width: '100%', borderRadius: '20px 20px 0px 0px', padding: '20px 0px 90px 20px', position: 'absolute', bottom: '0px' }}>
                                        <div style={{ color: '#FFFFFF', fontSize: '18px', fontWeight: 600 }}>
                                            Share with Personal Message
                                        </div>
                                        <div style={{ width: '100%' }}>
                                            <textarea
                                                className="inputMessage"
                                                placeholder="Write a message for your friend to send gift. (Optional)"
                                                onChange={handelMessage}
                                            />
                                        </div>
                                    </div>
                                    <div className="popUpButtonContainer">
                                        <button onClick={() => {
                                            APIHelper.postAnalytics("send_gift");
                                            nativeEvents.shareWithFriends(message)
                                        }} className="popUpButton">
                                            SEND GIFT
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal>
                )
            }
        </div>
    )
}